import 'leaflet.gridlayer.googlemutant/dist/Leaflet.GoogleMutant'

import { createLayerComponent, updateGridLayer } from '@react-leaflet/core'
import L from 'leaflet'

export type GoogleMutantLayerProps = L.gridLayer.GoogleMutantOptions

export const GoogleMutantLayerComponent = createLayerComponent<
  L.GridLayer,
  GoogleMutantLayerProps
>((props, context) => {
  const instance = L.gridLayer.googleMutant({
    ...props,
    zIndex: 0,
    pane: 'tilePane',
  })
  return { instance, context }
}, updateGridLayer)
